module.exports = __webpack_public_path__ + "img/ignition-on.dbfe9602.svg";